import React, { createContext, useContext, useState, useCallback } from "react";

const FormContext = createContext(null);

export const useEnquiryForm = () => useContext(FormContext);

export const FormProvider = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [defaultType, setDefaultType] = useState("founder");
  const [prefill, setPrefill] = useState({});

  const openForm = useCallback((type = "founder", data = {}) => {
    setDefaultType(type);
    setPrefill(data || {});
    setOpen(true);
  }, []);

  return (
    <FormContext.Provider value={{ open, setOpen, defaultType, prefill, openForm }}>
      {children}
    </FormContext.Provider>
  );
};
